



















import { Component, Mixins } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

// Mixins
import Phone from '@/mixins/Phone'
import Errors from '@/mixins/Errors'

// Components
import ModalWrapper from '@/components/common/ModalWrapper.vue'

@Component({
  components: {
    ModalWrapper
  }
})
export default class DownloadAppModal extends Mixins(Errors, Phone) {
  phone: string = null
  loading = false
  $parent: any

  @Getter('token') token

  async getSms() {
    try {
      this.loading = true
      const res = await this.$api.user.getAppSms(this.token, this.phone)
      this.$parent.close()
      this.$toast.open({
        message: this.$t('cta.header.notifications.content.download_app') as string,
        type: 'is-success',
        duration: 5000
      })
    } catch (error) {
      this.displayErrors(error)
    } finally {
      this.loading = false
    }
  }
}
